import React from "react";
import { FormattedMessage } from "react-intl";
import { ExternalLink } from "@smartling-ui/link";
import messages from "./messages";

export function LinkTermsAndConditions() {
    return (
        <ExternalLink
            href="https://www.smartling.com/smartling-trial"
            size="inherit"
            weight="inherit"
        >
            <FormattedMessage
                {...messages.termsAndConditionsLink}
            />
        </ExternalLink>
    );
}
